import { render, staticRenderFns } from "./PropertyEnquiryFooter.vue?vue&type=template&id=5904cbb0"
import script from "./PropertyEnquiryFooter.vue?vue&type=script&lang=js"
export * from "./PropertyEnquiryFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports